import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import $ from 'jquery';

// Signup
// ==========================================
// Signup: Common
import Help from './_common/help';
import { Navbar } from './_common/navbar';
import { SkipRegister } from './_common/skipRegister';
import photoWoman from './../../../assets/images/placeholder/photo-woman.jpeg';
import { resetUser } from './../../../actions/user-api';
import { resetAuth } from './../../../actions/auth-api';

// Signup: Views
import { Step1 } from './step1';
import { Step2 } from './step2';
import { Step3 } from './step3/index';
// import Step3 from './step3/_oldindex';
import { Step4 } from './step4';
import { Step5 } from './step5';
import { Step6 } from './step6';
import * as R from 'ramda';
import { fetchUserById, getUserAddress, getUserRepresentatives, getUserRepresentativeAddress, getUserServices } from '../../../actions/user-api';
import JwtDecode from 'jwt-decode';

export const PartnerSignup = () => {
  const router = useSelector(state => state.router);
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const auth = useSelector(state => state.auth);
  const [passwordRequirements, setPasswordRequirements] = useState({ hasLower: false, hasUpper: false, hasDigits: false });
  const [personalDataRequirements, setPersonalDataRequirements] = useState({
    civil: false,
    familiar: false,
    children: false,
    contact: false,
    profession: false
  });
  const [monReferentRequirements, setMonReferentRequirements] = useState({ principal: false, other: false });
  const [monServiceRequirements, setMonServiceRequirements] = useState({ communes: true, personnal: false });
  const hideModal = () => {
    $('.modal').modal("hide");
  };

  let pathname = router.location.pathname.toLowerCase();
  let stepNum = pathname.substring(17, 18);
  let step = stepNum !== '' ? parseInt(stepNum) : 1;
  const [stepsCompleted, setStepsCompleted] = useState([]);

  useEffect(() => {
    var accessToken = localStorage.getItem("access_token");
    if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
      var decoded = JwtDecode(accessToken);
      if (!R.isNil(decoded) && !R.isNil(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"])) {
        dispatch(fetchUserById(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    var accessToken = localStorage.getItem("access_token");
    if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
      var decoded = JwtDecode(accessToken);
      if (!R.isNil(decoded) && !R.isNil(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]) && user.user === undefined) {
        dispatch(fetchUserById(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);


  useEffect(() => {
    let tmpUser = user.user;
    if (!R.isNil(tmpUser)) {
      dispatch(getUserAddress(tmpUser.id));
      dispatch(getUserRepresentatives(tmpUser.id));
      dispatch(getUserServices(tmpUser));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.user]);

  useEffect(() => {
    if (!R.isNil(user.referents) && user.referents.length > 0) {
      user.referents.forEach(r => {
        dispatch(getUserRepresentativeAddress(r));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.referents]);

  function checkSteps() {
    let tmpSteps = [];
    let tmpUser = user.user;
    let step = !R.isNil(user) && !R.isNil(tmpUser) && !R.isNil(tmpUser.onBoardingStep) ? parseInt(JSON.stringify(tmpUser.onBoardingStep).replace(/\D/g, "")) : -1;
    if (step !== 6 && step !== -1) {
      if (tmpUser.onBoardingStep === "Completed") {
        step = 6;
      }
    }

    if (step !== -1) {
      tmpSteps = Array.from({ length: step }, (_, i) => i + 1);
    }
    setStepsCompleted(tmpSteps);
  }

  useEffect(() => {
    if (!R.isNil(user.user)) {
      checkSteps();
    }
    if (step === 1 && !stepsCompleted.includes(1) && (auth.loggedIn !== true || user.user === undefined)) {
      $('#commencerRegister').modal('show');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <div className="layout layout-row bg-gradient-primary">
      <h1 className="sr-only visually-hidden">Assist@</h1>
      <Navbar stepsCompleted={stepsCompleted} passwordRequirements={passwordRequirements} step={step}
        personalDataRequirements={personalDataRequirements} monReferentRequirements={monReferentRequirements}
        monServiceRequirements={monServiceRequirements} />
      <main role="main" className="view flex-grow-1 bg-gradient-light">
        <h1 className="sr-only visually-hidden">Assist@: Main</h1>
        <Help />
        {
          step === 1 ? <Step1 passwordRequirements={passwordRequirements} setPasswordRequirements={(req) => { setPasswordRequirements(req); }} /> :
            step === 2 ? <Step2 personalDataRequirements={personalDataRequirements} setPersonalDataRequirements={(req) => setPersonalDataRequirements(req)} /> :
              step === 3 ? <Step3 monReferentRequirements={monReferentRequirements} setMonReferentRequirements={(req) => setMonReferentRequirements(req)} /> :
                step === 4 ? <Step4 monServiceRequirements={monServiceRequirements} setMonServiceRequirements={(req) => { setMonServiceRequirements(req); }} /> :
                  step === 5 ? <Step5 /> :
                    step === 6 ? <Step6 /> :
                      ''
        }
      </main>
      {/* <SkipRegister /> */}
    </div>
  );
};
